import React from 'react';
import "./SvgContainer.css"

import Svg1 from "../Assets/svg/svg2.png";

function SvgContainer() {
  return (
    <div className='svg-container2 svg-container'>
        <img src={Svg1} alt='' />
    </div>
  )
}

export default SvgContainer